/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExerciseData } from './exercise-data';

/**
 * 
 * @export
 * @interface ExerciseCreateRequest
 */
export interface ExerciseCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof ExerciseCreateRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'url'?: string;
    /**
     * 
     * @type {ExerciseData}
     * @memberof ExerciseCreateRequest
     */
    'data'?: ExerciseData;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'group'?: ExerciseCreateRequestGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'type'?: ExerciseCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'equipment'?: ExerciseCreateRequestEquipmentEnum;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'level'?: ExerciseCreateRequestLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof ExerciseCreateRequest
     */
    'authorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCreateRequest
     */
    'authorName'?: string;
}

export const ExerciseCreateRequestGroupEnum = {
    Gluteus: 'GLUTEUS',
    Chest: 'CHEST',
    Back: 'BACK',
    Shoulders: 'SHOULDERS',
    Harmstrings: 'HARMSTRINGS',
    Quadriceps: 'QUADRICEPS',
    Biceps: 'BICEPS',
    Triceps: 'TRICEPS',
    Abs: 'ABS',
    Calves: 'CALVES',
    Traps: 'TRAPS',
    Neck: 'NECK',
    Adductors: 'ADDUCTORS',
    Abductors: 'ABDUCTORS'
} as const;

export type ExerciseCreateRequestGroupEnum = typeof ExerciseCreateRequestGroupEnum[keyof typeof ExerciseCreateRequestGroupEnum];
export const ExerciseCreateRequestTypeEnum = {
    Cardio: 'CARDIO',
    OlympicWeightlighting: 'OLYMPIC_WEIGHTLIGHTING',
    Plyometrics: 'PLYOMETRICS',
    Powerlifting: 'POWERLIFTING',
    Stretching: 'STRETCHING',
    Strength: 'STRENGTH',
    Strongman: 'STRONGMAN',
    Calisthenics: 'CALISTHENICS'
} as const;

export type ExerciseCreateRequestTypeEnum = typeof ExerciseCreateRequestTypeEnum[keyof typeof ExerciseCreateRequestTypeEnum];
export const ExerciseCreateRequestEquipmentEnum = {
    Bands: 'BANDS',
    FoamRoll: 'FOAM_ROLL',
    Kettlebells: 'KETTLEBELLS',
    Bodyweight: 'BODYWEIGHT',
    Machine: 'MACHINE',
    Cable: 'CABLE',
    MedicineBall: 'MEDICINE_BALL',
    ExerciseBall: 'EXERCISE_BALL',
    Dumbbell: 'DUMBBELL',
    Barbell: 'BARBELL',
    Other: 'OTHER'
} as const;

export type ExerciseCreateRequestEquipmentEnum = typeof ExerciseCreateRequestEquipmentEnum[keyof typeof ExerciseCreateRequestEquipmentEnum];
export const ExerciseCreateRequestLevelEnum = {
    Beginner: 'BEGINNER',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT'
} as const;

export type ExerciseCreateRequestLevelEnum = typeof ExerciseCreateRequestLevelEnum[keyof typeof ExerciseCreateRequestLevelEnum];


